import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { EStageId, EStageType } from '../../utils/journeysUtils';

// GraphQL mutation
const UPSERT_JOURNEY_HISTORY_MUTATION = gql`
  mutation upsertJourneyHistory($journeyId: String!, $history: StageHistoryInput!) {
    upsertJourneyHistory(id: $journeyId, history: $history) {
      _id
      currentStage
      history {
        stageId
        type
        completedAt
        details
      }
    }
  }
`;

// Input types for TypeScript
export interface StageHistoryInputType {
  stageId: EStageId;
  type: EStageType;
  completedAt: string; // ISO string
  details?: string;
}

export interface UpsertJourneyHistoryMutationType {
  upsertJourneyHistory: {
    _id: string;
    journeyId: string;
    currentStage: EStageId;
    history: {
      stageId: EStageId;
      type: EStageType;
      completedAt: string;
      details?: string;
    }[];
  };
}

export interface UpsertJourneyHistoryMutationVariables {
  journeyId: string;
  history: StageHistoryInputType;
}

// Custom hook
export function useUpsertJourneyHistoryMutation(
  options?: MutationHookOptions<
    UpsertJourneyHistoryMutationType,
    UpsertJourneyHistoryMutationVariables
  >,
) {
  return useMutation<UpsertJourneyHistoryMutationType, UpsertJourneyHistoryMutationVariables>(
    UPSERT_JOURNEY_HISTORY_MUTATION,
    options,
  );
}
